import type { ValidationSchema } from '@wix/editor-elements-corvid-utils';

export const lottieSDKValidationSchema: ValidationSchema = {
  type: ['object'],
  properties: {
    src: {
      type: ['string', 'object'],
    },
    speed: {
      minimum: 0,
      type: ['number'],
    },
    loop: {
      type: ['boolean'],
    },
    autoplay: {
      type: ['boolean'],
    },
    showPlayPauseControl: {
      type: ['boolean'],
    },
    direction: {
      type: ['string'],
    },
  },
};
